import React from 'react';
import PropTypes from 'prop-types';
import __ from '../../helpers/translation';

const propTypes = {
  current: PropTypes.object,
};

function StopInspectionModal(props) {

    return (
        <div className="modal fade" id="stopReasonModal" tabIndex="-1" role="dialog" aria-labelledby="stopReasonModal" aria-hidden="true">
            <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div className="modal-content p-3 p-sm-5">
                    <div className="modal-header">
                        <h1 className="modal-title fw-600">
                            { __('app.questions.stop_reason_popup_title') }
                        </h1>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        {props.current && props.current.question_data.stop_reason ?
                            (
                                <div dangerouslySetInnerHTML={{__html: props.current.question_data.stop_reason.replace(/(<? *script)/gi, 'illegalscript')}}></div>
                            ) : ('')
                        }
                        <button className="btn btn-success d-block w-100 mt-5" data-dismiss="modal" aria-label="Close">
                            { __('app.questions.stop_reason_popup_button') }
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
  
}

StopInspectionModal.propTypes = propTypes;

export default StopInspectionModal;